export const CREDIT_USAGE_REPORT_LANDING = 'CREDIT_USAGE_REPORT_LANDING';
export const CREDIT_USAGE_REPORT_LANDING_PENDING = 'CREDIT_USAGE_REPORT_LANDING_PENDING';
export const CREDIT_USAGE_REPORT_LANDING_FULFILLED = 'CREDIT_USAGE_REPORT_LANDING_FULFILLED';
export const CREDIT_USAGE_REPORT_LANDING_REJECTED = 'CREDIT_USAGE_REPORT_LANDING_REJECTED';

export const CREDIT_USAGE_REPORT_DOWNLOAD = 'CREDIT_USAGE_REPORT_DOWNLOAD';
export const CREDIT_USAGE_REPORT_DOWNLOAD_PENDING = 'CREDIT_USAGE_REPORT_DOWNLOAD_PENDING';
export const CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED = 'CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED';
export const CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED = 'CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED';

export const CREDIT_USAGE_REPORT_RESET = 'CREDIT_USAGE_REPORT_RESET';

export const AI_CREDIT_USAGE_REPORT_LANDING = 'AI_CREDIT_USAGE_REPORT_LANDING';
export const AI_CREDIT_USAGE_REPORT_LANDING_PENDING = 'AI_CREDIT_USAGE_REPORT_LANDING_PENDING';
export const AI_CREDIT_USAGE_REPORT_LANDING_FULFILLED = 'AI_CREDIT_USAGE_REPORT_LANDING_FULFILLED';
export const AI_CREDIT_USAGE_REPORT_LANDING_REJECTED = 'AI_CREDIT_USAGE_REPORT_LANDING_REJECTED';

export const AI_CREDIT_USAGE_REPORT_DOWNLOAD = 'AI_CREDIT_USAGE_REPORT_DOWNLOAD';
export const AI_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING = 'AI_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING';
export const AI_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED = 'AI_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED';
export const AI_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED = 'AI_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED';

export const AI_CREDIT_USAGE_REPORT_RESET = 'AI_CREDIT_USAGE_REPORT_RESET';

export const SYSTEM_CREDIT_USAGE_REPORT_LANDING = 'SYSTEM_CREDIT_USAGE_REPORT_LANDING';
export const SYSTEM_CREDIT_USAGE_REPORT_LANDING_PENDING = 'SYSTEM_CREDIT_USAGE_REPORT_LANDING_PENDING';
export const SYSTEM_CREDIT_USAGE_REPORT_LANDING_FULFILLED = 'SYSTEM_CREDIT_USAGE_REPORT_LANDING_FULFILLED';
export const SYSTEM_CREDIT_USAGE_REPORT_LANDING_REJECTED = 'SYSTEM_CREDIT_USAGE_REPORT_LANDING_REJECTED';

export const SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD = 'SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD';
export const SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING = 'SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING';
export const SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED = 'SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED';
export const SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED = 'SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED';

export const SYSTEM_CREDIT_USAGE_REPORT_RESET = 'SYSTEM_CREDIT_USAGE_REPORT_RESET';

export const creditsUsageReportLanding = (startDate, endDate) => {
    return {
        type: CREDIT_USAGE_REPORT_LANDING,
        payload: { startDate, endDate },
    }
}

export const downloadCreditUsageReport = (startDate, endDate, callback) => ({
    type: CREDIT_USAGE_REPORT_DOWNLOAD,
    payload: { startDate, endDate, callback }
});

export const resetCreditUsageReport = () => ({
    type: CREDIT_USAGE_REPORT_RESET
});

export const aiCreditsUsageReportLanding = (startDate, endDate) => {
    return {
        type: AI_CREDIT_USAGE_REPORT_LANDING,
        payload: { startDate, endDate },
    }
}

export const aiDownloadCreditUsageReport = (startDate, endDate, callback) => ({
    type: AI_CREDIT_USAGE_REPORT_DOWNLOAD,
    payload: { startDate, endDate, callback }
});

export const aiResetCreditUsageReport = () => ({
    type: AI_CREDIT_USAGE_REPORT_RESET
});

export const systemCreditsUsageReportLanding = (startDate, endDate) => {
    return {
        type: SYSTEM_CREDIT_USAGE_REPORT_LANDING,
        payload: { startDate, endDate },
    }
}

export const systemDownloadCreditUsageReport = (startDate, endDate, callback) => ({
    type: SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD,
    payload: { startDate, endDate, callback }
});

export const systemResetCreditUsageReport = () => ({
    type: SYSTEM_CREDIT_USAGE_REPORT_RESET
});